import map from 'lodash/fp/map'
import pipe from 'lodash/fp/pipe'
import reduce from 'lodash/fp/reduce'
import * as Elasticsearch from '../../elasticsearch'
import * as Types from './types'

export const selectUniqueCount = pipe(
  Elasticsearch.selectAggBuckets(Elasticsearch.AggFieldNames.TotalCount),
  Elasticsearch.selectUniqueCount,
)
export const selectUniqueAggCount = pipe(
  Elasticsearch.selectAggBuckets(Elasticsearch.AggFieldNames.TotalCount),
  map(Elasticsearch.selectUniqueCount),
  reduce((a, b) => a + b, 0),
)
export const asPercentage = Elasticsearch.asPercentage
export const selectTotalCountFromBucket: any = pipe(
  Elasticsearch.findTimeBucket,
  Elasticsearch.selectDocCount,
)
export const selectUniqueCountFromBucket: any = pipe(
  Elasticsearch.findTimeBucket,
  Elasticsearch.selectUniqueCount,
)

type GetAverageNewsLettersSent = (issuesArray: Types.Issue[]) => number
export const getAverageNewsLettersSent: GetAverageNewsLettersSent =
  (issuesArray) =>
    issuesArray.length > 0 ?
      Math.floor(issuesArray.map((issue) => issue.expected).reduce((a, b) => a + b, 0) / issuesArray.length)
    : 0



// WEBPACK FOOTER //
// ./src/pages/home/utils.ts